"use strict";

export default function templateCourseProgress(subscription) {
  let html = `<div class="header">`;
  html += parseInt(subscription.progress) == 100 ? `You have completed the course` : `Your progress so far...`;
  html += `</div><div class="content">`;
  if (parseInt(subscription.progress) != 100)
    html += `<div class="clearfix"><div class="pull-left">Lessons completed: </div><div class="pull-right"><strong>${subscription.progress}%</strong></div></div>`;
  // html += `<div class="clearfix"><div class="pull-left">Grade: </div><div class="pull-right"><strong>${subscription.grade}%</strong></div></div></div>`
  return html;
}
